<div class="generic-spacer">
    <product-info [products]="products"></product-info>
</div>